import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import * as _ from 'lodash-es';
import { tap, take, takeUntil, switchMap, mergeMap, retryWhen, map, delay } from 'rxjs/operators';
import { Observable, Subject, defer, BehaviorSubject } from 'rxjs';
import { CasualHireFormService } from '../../casual-hire-form.service';
import { LoadingComponentService } from '@gwc/loading/loading-component.service';
import { GwcApiInstitutionQualificationRegaliaService } from '@gwc/datasources/gwc-api/institution-qualification-regalia.service';
import { f3Animations } from '@f3/animations';
import { faFilePdf, faFile, faCheckCircle, faTimesCircle } from '@fortawesome/free-solid-svg-icons'
import { UntypedFormControl, ReactiveFormsModule } from '@angular/forms';
import { InstitutionQualificationRegalia } from '@gwc/datasources/gwc-api/types/institution-qualification-regalia.types';
import { environment } from 'projects/casual-hire-form/src/environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { MultiGownSelectDialogComponent } from '../../dialog/multi-gown-select-dialog/multi-gown-select-dialog.component';
import { InstitutionQualification } from '@gwc/datasources/gwc-api/types/institution-qualification.types';
import { ConfirmationDialogComponent } from '../../dialog/confirmation-dialog/confirmation-dialog.component';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel, MatHint } from '@angular/material/form-field';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgTemplateOutlet, AsyncPipe, CurrencyPipe } from '@angular/common';
import { LoadingModule } from '../../../../../../../../@gwc/loading/loading.module';


@Component({
    selector: 'gwc-frontend-select-regalia',
    templateUrl: './select-regalia.component.html',
    encapsulation: ViewEncapsulation.None,
    animations: f3Animations,
    standalone: true,
    imports: [LoadingModule, NgTemplateOutlet, FaIconComponent, MatFormField, MatInput, ReactiveFormsModule, MatSelect, MatOption, AsyncPipe, CurrencyPipe]
})
export class HireFormSelectRegliaCopmonent implements OnInit, OnDestroy {

	// @Public Properties
	public apiBaseUrl = environment.apiBaseUrl
	public imageBaseUrl = environment.imageBaseUrl

	public regalia$ = new BehaviorSubject<InstitutionQualificationRegalia[]>([])

	public currentCurrency = 'NZD';

	public readonly defaultCurrency = 'NZD';

	public faFilePdf = faFilePdf;

	public faFile = faFile;

	public faCheckCircle = faCheckCircle
	public faTimesCircle = faTimesCircle

	public headCircumference: UntypedFormControl = new UntypedFormControl();

	public gownHeight: UntypedFormControl = new UntypedFormControl();


	// @Private Properties
	private _unsubscribeAll: Subject<any> = new Subject

	private _selectedQualifications: InstitutionQualification[] = [];

	private _selectedRegalia: InstitutionQualificationRegalia[] = [];


	/**
	 * Constructor
	 */
	constructor(
		private _matDialog: MatDialog,
		private _loadingSerivce: LoadingComponentService,
		private _casualHireFormService: CasualHireFormService,
		private _gwcApiInstitutionQualificationRegaliaService: GwcApiInstitutionQualificationRegaliaService
	) { }


	//--------------------------------------------------------------------------------
	// @Lifecycle Hooks
	//--------------------------------------------------------------------------------

	/**
	 * On Init
	 */
	ngOnInit(): void {

		this._casualHireFormService.orderData$.pipe(
			takeUntil(this._unsubscribeAll)
		).subscribe({
			next: (orderData) => {
				this._applyOrderDataRegalia(orderData);
			}
		});

		//get the orderData and then then the regalia
		this._casualHireFormService.orderData$.pipe(
			take(1),
			mergeMap((orderData) => {
				this._selectedRegalia = orderData.regalia

				if(this._selectedRegalia.length > 0) {
					this._casualHireFormService.updateStepValidity(true)
				}

				this._selectedQualifications = orderData.qualifications;

				return this._gwcApiInstitutionQualificationRegaliaService.get(orderData.qualifications.map((qual: any) => qual.institution_qualification_id))
			}),
		).subscribe({
			next: (regalia: InstitutionQualificationRegalia[]) => {
				//stop the loader circle
				
				let processedRegalia: InstitutionQualificationRegalia[] = [];

				//put all regalia together into the array, limit the gowns and hats into one type of
				regalia.map((regalia: any) => {
					if(!processedRegalia.find(reg => reg.regalia_id === regalia.regalia_id)) {
						processedRegalia.push(_.merge(regalia, { data: {} }))
					}
				})

				//sort the regalia
				processedRegalia = _.orderBy(processedRegalia, ['regalia.list_regalia_cat.rank'], ['asc']);

				//make sure the items are selected
				if(this._selectedRegalia.length === 0) {
					processedRegalia.map(reg => this._selectedRegalia.push(reg))
					this._casualHireFormService.updateStepValidity(true)
				} else if(this._selectedRegalia.filter(reg => reg.institution_qualification_regalia_id !== 'late_fee').length !== 0) {
					_.remove(this._selectedRegalia.filter(reg => reg.institution_qualification_regalia_id !== 'late_fee'), (selectedItem) => processedRegalia.findIndex(reg => reg.regalia_id === selectedItem.regalia_id) === -1)
				}
				
				this._casualHireFormService.addToOrderData('regalia', this._selectedRegalia, this._selectedRegalia.length > 0 ? true : false)

				//determine whether to the open the multi gown dialog
				// if(this._selectedInstitutionQualifications[0].qualification.list_qualification_type_id === '95a2ab2d-a74c-4482-aa45-0daaabf871f3' && this._regalia.filter(regalia => regalia.regalia?.list_regalia_cat_id === '8d30a040-afeb-42f8-bd3c-cd20c34ced7f').length > 1) {
				if(this._selectedQualifications[0].qualification.list_qualification_type_id === '95a2ab2d-a74c-4482-aa45-0daaabf871f3' && processedRegalia.filter(reg => reg.regalia?.list_regalia_cat_id === '8d30a040-afeb-42f8-bd3c-cd20c34ced7f').length > 1) {
					this._openMultiGownDialog();
				}

				//stop the loading service				
				this._loadingSerivce.stop('regaliaLoader');

				//put the processed 
				this.regalia$.next(processedRegalia) 
			}
		})
		
	}

	/**
	 * On Destroy
	 */
	ngOnDestroy(): void {
		this._casualHireFormService.updateStepValidity(false)

		this._unsubscribeAll.next(null)
		this._unsubscribeAll.complete()
	}


	//--------------------------------------------------------------------------------
	// @Public Methods
	//--------------------------------------------------------------------------------

	/**
	 * determines if the page is loading
	 */
	public pageIsLoading() {
		return this._loadingSerivce.isLoading('regaliaLoader');
	}

	/**
	 * Toggle the selected regalia
	 */
	public toggleSelectedRegalia(institutionQualificationReglaia: InstitutionQualificationRegalia) {

		const reg: InstitutionQualificationRegalia[] = [...this._selectedRegalia];
		const index = reg.findIndex((regalia: any) => regalia.regalia_id == institutionQualificationReglaia.regalia_id);

		if (index === -1) {
			reg.push(institutionQualificationReglaia)
			this._selectedRegalia = reg;
			this._casualHireFormService.addToOrderData('regalia', reg, reg.length > 0 ? true : false);
		} else {
			const dialogRef = this._matDialog.open(ConfirmationDialogComponent, {
        width: '250px',
        data: { title: 'Warning', message: "Are you sure you want to remove this regalia item?" }
      });

      dialogRef.afterClosed().subscribe((result: any) => {
				console.log(result)
        if (result) {
					reg.splice(reg.findIndex((regalia: any) => regalia.regalia_id == institutionQualificationReglaia.regalia_id), 1);
					this._selectedRegalia = reg;
		this._casualHireFormService.addToOrderData('regalia', reg, reg.length > 0 ? true : false);
        }
      });

		}


		
	}

	/**
	 * Check whether the regalia item has been selected
	 */
	public isRegaliaSelected(regaliaDetails: InstitutionQualificationRegalia): boolean {
		if(!regaliaDetails) return false;

		return this._selectedRegalia.findIndex((regalia: any) => regalia.regalia_id === regaliaDetails.regalia_id) > -1
	}

	/**
	 * 
	 */
	gownHeightSelected(institution_qualification_regalia_id: string) {

		//get the selected regalia
		const sReg = [...this._selectedRegalia];

		//first see if the item isn't selected
		const sRegFound = 	_.find(sReg, function(reg) { return reg.institution_qualification_regalia_id === institution_qualification_regalia_id})

		if(sRegFound) {
			sRegFound.data = { gownHeight: this.gownHeight.value }
		} else {
			this.regalia$.pipe(
				take(1)
			).subscribe({
				next: (regalia) => {
					sReg.push(_.merge(regalia.find(reg => reg.institution_qualification_regalia_id == institution_qualification_regalia_id), { data: { gownHeight: this.gownHeight.value }}))

				},
				complete: () => console.log('complete')
			})

		}
		console.log(sReg)
		this._casualHireFormService.addToOrderData('regalia', sReg, true);
	}

	/**
	 * 
	 */
	 public headCircumferenceSelected(institution_qualification_regalia_id: string) {
		const sReg = [...this._selectedRegalia];

		const sRegFound = 	_.find(sReg, function(reg) { return reg.institution_qualification_regalia_id === institution_qualification_regalia_id})

		if(sRegFound) {
			sRegFound.data = { headCircumference: this.headCircumference.value }
		} else {
			this.regalia$.pipe(
				take(1)
			).subscribe({
				next: (regalia) => {
					sReg.push(_.merge(regalia.find(reg => reg.institution_qualification_regalia_id == institution_qualification_regalia_id), { data: { headCircumference: this.headCircumference.value }}))


				},
				complete: () => console.log('complete')
			})
		}

		this._casualHireFormService.addToOrderData('regalia', sReg, true);
		
	}

	public preventNegative(event: KeyboardEvent) {
		if (event.key === '-') {
			event.preventDefault();
		}
	}

	public blurInput(event: Event) {
		(event.target as HTMLElement).blur();
	}

	//--------------------------------------------------------------------------------
	// @Private Methods
	//--------------------------------------------------------------------------------

	private _openMultiGownDialog() {

		const dialog = this._matDialog.open(MultiGownSelectDialogComponent, {
			width: '800px',
			data: {

			}
		})

		dialog.afterClosed().pipe(
			map(degree => {

				let list_regalia_sub_cat_id: string | null = null

				if(degree === 'masters') {
					//remove the bachelors gowns
					list_regalia_sub_cat_id = 'b571f8a2-ae0a-46b1-b2ed-7b2f6a6a0cfc'
				} else if(degree === 'bachelors') {
					//remove the masters gown
					list_regalia_sub_cat_id = '35cbaaf2-68a0-43e7-99c1-1520ff8aa7c4'
				}

				if(list_regalia_sub_cat_id) {


					// _.remove(this._regalia, (regalia) => regalia.regalia?.list_regalia_sub_cat_id === list_regalia_sub_cat_id);
					// _.remove(this._selectedRegalia, (regalia) => regalia.regalia?.list_regalia_sub_cat_id === list_regalia_sub_cat_id);
					// this._orderService.updateOrder('regalia', this._selectedRegalia)


				}

			})
		).subscribe()
	}	

	private _applyOrderDataRegalia(orderData: any): void {
		const regalia = orderData?.regalia ?? [];
		this._selectedRegalia = regalia;
		if (regalia.length) {
			const ordered = this._sortRegalia(regalia);
			this.regalia$.next(ordered);
			const currencyMatch = regalia.find((item: any) => item?.currency);
			this.currentCurrency = currencyMatch?.currency || this.defaultCurrency;
		} else {
			this.regalia$.next([]);
			this.currentCurrency = this.defaultCurrency;
		}
	}

	private _sortRegalia(regalia: InstitutionQualificationRegalia[]): InstitutionQualificationRegalia[] {
		if (!regalia?.length) {
			return [];
		}

		return _.orderBy(regalia, ['regalia.list_regalia_cat.rank'], ['asc']);
	}

	public resolveCurrency(regalia: InstitutionQualificationRegalia | null): string {
		if (!regalia) {
			return this.currentCurrency || this.defaultCurrency;
		}

		// Currency is stored in the data field or determined from currentCurrency
		const currency = (regalia as any).currency || (regalia.data as any)?.currency;
		return currency || this.currentCurrency || this.defaultCurrency;
	}



}
